import { useEffect, useState } from 'react';

type PotentialMobileWindow = Window & {
  opera?: any;
  MSStream?: any;
};

type MobileDeviceOSIdentifier = 'WindowsPhone' | 'Android' | 'iOs';

type PotentialMobileDeviceOSIdentifier = MobileDeviceOSIdentifier | undefined;

/**
 * Returns the mobile OS identifier if the user agent is a mobile OS.
 * You can pass in a value to use for SSR.
 */
const useMobileOs = (
  ssrValue?: MobileDeviceOSIdentifier,
): PotentialMobileDeviceOSIdentifier => {
  const [os, setOs] = useState<PotentialMobileDeviceOSIdentifier>(ssrValue);

  useEffect(() => {
    if (!window) {
      return;
    }

    setOs(getMobileOsFromWindow(window));
  }, []);

  return os;
};

const getMobileOsFromWindow = (
  window: PotentialMobileWindow,
): PotentialMobileDeviceOSIdentifier => {
  const userAgent =
    window.navigator.userAgent || window.navigator.vendor || window.opera;

  if (!userAgent) {
    return undefined;
  }

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'WindowsPhone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOs';
  }

  return undefined;
};

export default useMobileOs;
